import React from 'react';
import { Button, Card, CardContent } from '@material-ui/core';
import { Route, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CoverEditor from '../../organisms/CoverEditor';

const cover_definition = [
  {
    name: "Acceuil",
    cover: "home",
    collection: "all",
    params: {
      type: ["decryptage", "rdv", "pepite", "podcast"],
    }
  },
  {
    name: "AtlanticoLight",
    cover:"atlantico-light",
    collection: "atlantico-lights",
  },
  {
    name: "Decryptage",
    cover: "decryptage",
    collection: "all",
    params: {
      type: ["decryptage", "rdv"]
    }
  },
  {
    name: "Dossier",
    cover: "dossier",
    collection: "dossiers",
  },
  {
    name: "Pepite",
    cover: "pepite",
    collection: "pepites"
  },
  {
    name: "Podcast",
    cover:"podcast",
    collection: "podcasts",
  },
  {
    name: "Rdv",
    cover:"rdv",
    collection: "rdvs"
  },
]

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-around',
    flex: 1
  },
  header: {
    marginBottom: '1vh'
  }
}));

const Cover = () => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <div>
      <Card className={classes.header}>
        <CardContent className={classes.buttons}>
          {cover_definition.map((e, i) => {
            return <Button key={i} variant={history.location.pathname === `/cover/${e.cover}` || (history.location.pathname === `/cover` && i === 0) ? 'contained' : 'outlined'} onClick={() => {
              history.push(`/cover/${e.cover}`);
            }}>{e.name}</Button>
          })}
        </CardContent>
      </Card>
      <Route key='home' exact path='/cover'>
        <CoverEditor
          cover_name={cover_definition[0].cover}
          collection_name={cover_definition[0].collection}
          article_list_params={{
            ...cover_definition[0].params,
            publish_date_lt: new Date(),
            publish_date_null: false,
            publish: true,
          }}
        />
      </Route>
      {cover_definition.map((e, i) => (
        <Route key={i} path={`/cover/${e.cover}`}>
          <CoverEditor
            cover_name={e.cover}
            collection_name={e.collection}
            article_list_params={{
              ...e.params,
              publish_date_lt: new Date(),
              publish_date_null: false,
            }}
          />
        </Route>
      ))}
    </div>
  );
}

export default Cover;